export const cleanEmbedListParams = (params) =>
    Object.entries(params).reduce((acc, [key, value]) => {
        if (value !== null && value !== '' && !(Array.isArray(value) && value.length === 0)) {
            acc[key] = value;
        }
        return acc;
    }, {});

export const buildEmbedListApiParams = (filters, sort, pagination) => {
    const params = {
        sort_by: sort.by,
        sort_direction: sort.direction,
    };

    if (pagination?.perPage) {
        params.per_page = pagination.perPage;
    }
    if (pagination?.page) {
        params.page = pagination.page;
    }

    if (filters.text?.trim()) {
        params.text = filters.text.trim();
    }
    if (Array.isArray(filters.department) && filters.department.length > 0) {
        params.department = filters.department.join(',');
    }
    if (Array.isArray(filters.trusted_domain) && filters.trusted_domain.length > 0) {
        params.trusted_domain = filters.trusted_domain.join(',');
    }
    if (Array.isArray(filters.is_active) && filters.is_active.length > 0) {
        params.is_active = filters.is_active
            .map((v) => (v === true || v === 1 || v === '1' ? '1' : '0'))
            .join(',');
    }
    if (Array.isArray(filters.is_reachable) && filters.is_reachable.length > 0) {
        params.is_reachable = filters.is_reachable.join(',');
    }
    if (Array.isArray(filters.display_mode) && filters.display_mode.length > 0) {
        params.display_mode = filters.display_mode.join(',');
    }
    if (filters.created_at) {
        params.created_at = filters.created_at;
    }
    if (filters.created_at === 'range' && Array.isArray(filters.created_at_range)) {
        params.created_at_range = filters.created_at_range.join(',');
    }

    return cleanEmbedListParams(params);
};

/**
 * Update one row's `is_active` without refetching the list.
 * When the active quick-filter is on, drop rows that no longer match.
 *
 * @param {Array<{ id: number|string, is_active?: boolean }>} rows
 * @param {number|string} id
 * @param {boolean} isActive
 * @param {'all' | 'enabled' | 'disabled'} activeFilter
 */
export const patchEmbedListRowActive = (rows, id, isActive, activeFilter) => {
    const next = rows.map((r) =>
        r.id === id ? { ...r, is_active: isActive } : r
    );
    if (activeFilter === "enabled") {
        return next.filter((r) => r.is_active);
    }
    if (activeFilter === "disabled") {
        return next.filter((r) => !r.is_active);
    }
    return next;
};
